// extracted by mini-css-extract-plugin
export var modal = "_g3-0";